function initProductCards() {
  // Color swatches functionality using event delegation
  const allCards = document.querySelectorAll(".card-product");

  allCards.forEach((product) => {
    handleRestNumber(product);

    product.addEventListener("click", (e) => {
      // Handle color swatches
      const colorOption = e.target.closest(
        ".card-product__color-option:not(.disabled)"
      );

      // Color Swatches Function
      if (colorOption) {
        e.preventDefault();
        handleColorSwatch(colorOption, product);
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initProductCards();
  window.initProductCards = initProductCards;
});

// Handle color swatch selection
function handleColorSwatch(colorOption, productCard) {
  // Check if already active
  if (colorOption.getAttribute("aria-current") === "true") return;

  const featuredImage = productCard.querySelector(
    ".card-product__image-container .card-product__image"
  );

  // Update active state
  colorOption
    .closest(".card-product__colors")
    .querySelectorAll(".card-product__color-option")
    .forEach((btn) => btn.setAttribute("aria-current", "false"));
  colorOption.setAttribute("aria-current", "true");

  // Update images
  const newImageSrc = colorOption.dataset.imageSrc;
  const newAltText = colorOption.dataset.imageAlt;

  if (featuredImage && newImageSrc) {
    featuredImage.src = newImageSrc;
    featuredImage.alt = newAltText;
  }
}

function handleRestNumber(product) {
  // COUNTER OF REST SWATCHES
  const colorsHolder = product.querySelector(".card-product__colors");
  const colorOptions = product.querySelectorAll(".card-product__color-option");
  if (colorsHolder && colorOptions.length > 4) {
    const restCounter = colorsHolder.querySelector(".rest-counter");
    const restNumber = colorOptions.length - 4;
    restCounter.style.display = "inline";
    restCounter.textContent = `+${restNumber}`;
  }
}
